<template>
	<div :style="getBackdrop()" class="pic col1">
		<div v-if="cardtype == 'movie'" class="movie-card pos-abs">
			<router-link :to="{ name: 'Movie', params: { movie_id: getMovieId() }}">
				<div class="dp-fx fx-al-end ht-full">
					<div class="tint-section">
						<div class="dp-fx fx-dr-col fx-al-ct cl-white pd-l-20 pd-r-20 pd-b-40">
							<div class="tx-ct mg-t-2 fz-12 fw-4">Nepotistic Rating</div>
							<div class="mg-t-6 dp-fx fx-al-ct">
								<div :class="`dp-fx fx-al-ct pd-t-6 pd-b-6 pd-l-10 pd-r-10 br-rd-5 nepo-gradient ${decision}`">
									<img v-if="decision=='up'" src="@/assets/heart.png" height=18 />
									<img v-else src="@/assets/heart-broken.png" height=18 />
									<span class="mg-l-6 fz-20">{{nepoRating}}</span>
									<span class="fz-12">/10</span>
								</div>
								<div class="pd-t-6 pd-b-6 pd-l-10 pd-r-10 solid-tint-black-black50 fz-12 fw-4">{{getTotalRatings()}}</div>
							</div>
							<div class="mg-t-10 cl-white fz-30 tx-ct">{{getTitle()}}</div>
							<div class="dp-fx fx-js-ct">
								<div class="dp-fx fx-al-ct">
									<img src="@/assets/clapboard.png" height=18 alt="Clapboard Icon"/>
									<div class="fz-14 lh-18 fw-4 tx-ct mg-l-6">{{getCastingDirectors()}}</div>
								</div>
							</div>
							<div class="mg-t-10 wd-full pd-l-20 pd-r-20">
								<div class="pd-l-24 pd-r-24 pd-t-8 pd-b-8 br-rd-15 solid-tint-black-black50 dp-fx fx-al-ct">
									<img src="@/assets/facemask.png" height=18 alt="Facemask Icon"/>
									<div class="fz-14 lh-18 fw-4 mg-l-10">{{getCastStars()}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</router-link>
		</div>
		<div v-else class="wd-full ht-full dp-fx fx-al-ct fx-js-ct">
			<div>
				<p class="fz-32 text-center cl-white fw-9 ">Invite your friends to rate</p>
				<div class="mg-t-20 text-center">
					<ShareNetwork
						v-for="network in networks"
						:network="network.network"
						:key="network.network"
						:url="sharing.url"
						:title="sharing.title"
						:description="sharing.description"
						:quote="getShareQuote()"
						:hashtags="sharing.hashtags"
						:twitterUser="sharing.twitterUser"
					>
						<div class="shb mg-r-10 fz-24 pd-t-6 text-center">
							<font-awesome-icon :icon="network.icon"/>
							<!-- {{ network.name }} -->
						</div>
					</ShareNetwork>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'MovieCard',
		props: ["movie", "imageBase"],
		components: {
		},
		data() {
			return {
				backgroundUrl:'',
				cardtype: 'movie',
				decision: 'down',
				sharing: {
					url: 'https://nepometer.co.in',
					title: 'For rating Bollywood\'s rampant nepotism, visit',
					description: 'Nepometer: A platform to voice your views',
					quote: 'Swipe and raise your voice!',
					hashtags: 'nepotism,nepometer',
					twitterUser: 'Nepometer_IN'
				},
				networks: [
					{ network: 'facebook', name: 'Facebook', icon: ['fab', 'facebook-f'], color: '#1877f2' },
					{ network: 'twitter', name: 'Twitter', icon: ['fab', 'twitter'], color: '#1da1f2' },
					{ network: 'whatsapp', name: 'Whatsapp', icon: ['fab', 'whatsapp'], color: '#25d366' },
				]
			};
		},
		methods: {
			getTitle() {
				var m = this.movie
				if (m.original_title == m.title) {
					return m.title
				}
				return m.original_title + ' (' + m.title + ')'
			},
			getBackdrop() {
				var m = this.movie, bg='';
				if ((typeof m.type != 'undefined') && (m.type == 'share')) {
					return this.getShareBackdrop();
				}
				if (m.backdrop_path !== null)
					bg = this.imageBase + m.backdrop_path
				else if (m.poster_path !== null)
					bg = this.imageBase + m.poster_path
				this.backgroundUrl = bg
				// return "{'backgroundImage': 'url("+bg+")'}";
				return "background-image: url("+bg+")";
				// {'background-image': `url(${backgroundUrl})`}
			},
			setBackdrop() {
				this.getBackdrop()
			},
			getMovieUrl() {
				return '/movie/'+this.movie.id;
			},
			getMovieId(){
				return this.movie.id;
			},
			getShareBackdrop() {
				return "background-image: linear-gradient(to bottom, #87e3fc, #4fc3f7)";
			},
			setNepometerRating() {
				var total = Math.max(1, this.movie.nepometer.likes + this.movie.nepometer.nopes);
				var nepoPercentage = 10 * this.movie.nepometer.likes / total;
				this.nepoRating = Math.round(nepoPercentage*10)/10;
				this.decision = (this.nepoRating > 5)?'down':'up';
			},
			getTotalRatings() {
				var total = this.movie.nepometer.likes + this.movie.nepometer.nopes;
				var substr = (total>1)? 'ratings' : 'rating';
				return total+' '+substr;
			},
			getCastStars() {
				var cast = this.movie.cast, names = []
				for (var i = 0; i < Math.min(4, cast.length); i++) {
					names.push(cast[i].name);
				}
				return names.join(', ');
			},
			getCastingDirectors() {
				if (typeof this.movie.crew === 'undefined') {
					return '';
				}
				let crew = this.movie.crew;
				let names = [];
				for (let i = 0; i < crew.length; i++) {
					let item = crew[i];
					if (item['job'] === 'Director') {
						names.push(item['name']);
					}
				}
				return names.join(', ')
			},
			getShareQuote() {
				let quotes = [
					"Nepometer: A platform to voice your views",
					"Swipe and raise your voice!"
				];
				return quotes[Math.floor(Math.random()*10)%quotes.length];
			},
		},
		created(){
			this.cardtype = (this.movie.type)?this.movie.type:this.cardtype;
			this.setBackdrop()
			this.setNepometerRating();
		}
	};
</script>

<style>
	.nepo-gradient.down{
		background: linear-gradient(135deg, #5D172E 0%, #490D20 100%);
	}
	.nepo-gradient.up{
		background: linear-gradient(135deg, #0B4D22 0%, #05411F 100%);
	}
	.pic {
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
		position: relative;
	}
	.movie-card{
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}
	.movie-card .tint-section{
		background: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, #000000 100%);
	}
	.tinder-card:nth-child(1) .pic{
		opacity: 1;
	}
	.tinder-card:nth-child(2) .pic{
		opacity: 0.8;
	}
	.tinder-card:nth-child(3) .pic{
		opacity: 0.6;
	}
	.tinder-card:nth-child(4) .pic{
		opacity: 0.4;
	}
	.tinder-card:nth-child(5) .pic{
		opacity: 0.2;
	}
	.shb {
		width: 46px;
		height: 46px;
		border-radius: 10px;
		background-color: #ffffff;
		color: #8b8b8b;
		display: inline-block;
	}
</style>
